// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"e4570ba2","787":"215a40b6"}[chunkId] + ".chunk.js";
};